import {Injectable} from '@angular/core';
import {teamStore} from './team.store';
import {select} from '@ngneat/elf';

@Injectable({providedIn: 'root'})
export class TeamQuery {
  teamData$ = teamStore.pipe(select(state => state.teamData));
  teamUnits$ = teamStore.pipe(select(state => state.teamUnits));
  currentTeamUnit$ = teamStore.pipe(select(state => state.currentTeamUnit));
  userMemberships$ = teamStore.pipe(select(state => state.userMemberships));
  filteredTeamMembers$ = teamStore.pipe(select(state => state.filteredTeamMembers));
  groups$ = teamStore.pipe(select(state => state.groups));
  filteredGroups$ = teamStore.pipe(select(state => state.filteredGroups));
  currentGroup$ = teamStore.pipe(select(state => state.currentGroup));
}
